<template>
  <v-form ref="MODE_CONNEXION" lazy-validation>
    <div>
      <section-header
          v-if="!hideTitle"
          ref="MODE_CONNEXION"
          :ressource="ressource"
          :is-extended="extended"
          :dialog="dialog"
          :prevent-close="dialog"
          @extended=setExtended
          @close-dialog=closeDialog>
      </section-header>
      <div v-if="extended" :class="dialog ? 'p-15' : 'py-2'">
        <mode-connexion
            ref="MODE_CONNEXION"
            :dialog="dialog"
            @close-dialog="closeDialog">
        </mode-connexion>
      </div>
    </div>

  </v-form>
</template>

<script lang="ts">
import {GenSection, RessourceGenSection} from '@/generated/ressources/generatedRessources';
import ModeConnexion from '@/framework/connection/components/ModeConnexion.vue';
import {Extended} from '@/framework/base/classes/Schema';
import SectionHeader from '@/framework/base/components/SectionHeader.vue';
import User from '@/generated/classes/User';
import {defineComponent, type PropType} from "vue";

export default defineComponent({
  components: {
    ModeConnexion,
    SectionHeader
  },
  props: {
    hideTitle: {
      type: Boolean
    },
    extended: {
      type: Boolean
    },
    dialog: {
      type: Boolean
    },
    user: {
      type: Object as PropType<User>
    }
  },
  computed: {
    ressource() {
      return RessourceGenSection(GenSection.MODE_CONNEXION);
    }
  },
  methods: {
    setExtended(extended: Extended): void {
      this.$emit('extended', extended);
    },
    closeDialog() {
      this.$emit('closeDialog');
    }
  }
})

</script>
